export const manuscriptFunctionUrl = path => {
  const functionsHost =
    process.env.NODE_ENV === 'development'
      ? (process.env.REACT_APP_FUNCTIONS_HOST || '').replace(/\/+$/, '')
      : '';

  return `${functionsHost}${path}`;
};
